import { Box } from '@mui/material';
import { SettingsSectionCardProps } from './settings-section-card.types';

/**
 * Untitled bordered container for setting rows. The card owns the hairline
 * dividers between adjacent rows (none after the last), so rows stay clean and
 * any number of children can be dropped in.
 */
export const SettingsSectionCard = ({ children }: SettingsSectionCardProps) => (
  <Box
    sx={{
      backgroundColor: (theme) =>
        theme.palette.mode === 'light'
          ? theme.palette.custom.OV.sys.surfaceContainerLowest
          : theme.palette.custom.OV.sys.surfaceContainer,
      border: '1px solid',
      borderColor: 'custom.OV.sys.outlineVariant',
      borderRadius: '10px',
      overflow: 'hidden',
      '& > *:not(:last-child)': {
        borderBottom: '1px solid',
        borderBottomColor: 'custom.OV.sys.outlineVariant',
      },
    }}
  >
    {children}
  </Box>
);

SettingsSectionCard.displayName = 'SettingsSectionCard';
